/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { useToast } from "../../contexts/ToastContext";
import { copyWithToast } from "../../lib/clipboard";

/** A bare copy-to-clipboard icon button with the toast-and-check feedback of CopyableId. */
export function CopyIconButton({ label, value }: { label: string; value: string }) {
  const { showToast } = useToast();
  const [copied, setCopied] = useState(false);

  async function copy() {
    const done = await copyWithToast(
      value,
      showToast,
      `${label} ID copied`,
      `Couldn't copy the ${label} ID`,
    );
    if (done) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  }

  return (
    <button
      type="button"
      onClick={() => void copy()}
      aria-label={`Copy ${label} ID ${value}`}
      title={`Copy ${label} ID`}
      className="rounded-md border border-border bg-bg-elevated p-1.5 text-text-tertiary transition-colors hover:border-border-hover hover:text-text-primary"
    >
      {copied ? <Check size={13} className="text-success" /> : <Copy size={13} />}
    </button>
  );
}
